import {studentTabActionTypes as types} from '../constants';
import initialState from './initialState';

function studentList(state = initialState.binderStudents.studentList, action) {
  switch (action.type) {
    case types.BINDER_STUDENTS_LOAD_REQUEST:
      return {...state, isError: false, isLoading: true};

    case types.BINDER_STUDENTS_LOAD_SUCCESS:
      return {...state, isError: false, isLoading: false, items: action.payload.data, filters: action.payload.filters};

    case types.BINDER_STUDENTS_LOAD_FAILURE:
      return {...state, isError: true, isLoading: false, error: action.error};

    default:
      return state;
  }
}

export default studentList;
